class dropDown {
    constructor(settings) {
        this.el = settings.el;
        this.container = settings.container;
        this.current = settings.current;
        this.list = settings.list;
        this.links = settings.links;
    }
    toggle() {
        this.el.toggleClass('open');
        if (this.el.hasClass('open')) {
            this.container.height(this.list.innerHeight() + this.el.height())
        } else {
            this.container.height(this.el.height())
        }
    }
}

const initDeduce = () => {
    const countDropDown = new dropDown({
        el: $('.js-deduce-select'),
        container: $('.js-deduce-container'),
        current: $('.js-deduce-caption'),
        list: $('.js-deduce-list'),
        links: $('.js-deduce-link'),
    });

    $(document).on('click', '.js-deduce-caption', function () {
        countDropDown.toggle();
    });

    $(document).on('click', '.js-deduce-link', function () {
        countDropDown.toggle();
        countDropDown.current.html($(this).html());
        $('.js-deduce-link').show();
        $(this).hide();
    });

    $(document).on('mouseup touchstart', function (e){
        let $block = $('.js-deduce-select');

        if (!$block.is(e.target) && $block.has(e.target).length === 0) {
            $block.removeClass('open');
        }
    });
}
const initSort = () => {
    const sortDropDown = new dropDown({
        el: $('.js-sort'),
        container: $('.js-sort-container'),
        current: $('.js-sort-caption'),
        list: $('.js-sort-list'),
        links: $('.js-sort-link'),
    });
    const contextOverlay = () => {
        if (sortDropDown.el.hasClass('open')) {
            $('.js-sectionListHeader').css('z-index', 15);
        } else {
            $('.js-sectionListHeader').css('z-index', 11);
        }
    }
    $(document).on('click', '.js-sort-caption', function () {
        sortDropDown.toggle();
        contextOverlay();
    });
    $(document).on('click', '.js-sort-link', function () {
        sortDropDown.toggle();

        const toggleText = sortDropDown.current.find('.js-sortToggle-text');
        const toggleLetters = sortDropDown.current.find('.js-sortToggle-letter');

        const $thisText = $(this).find('.js-sortLink-text').html();
        const $thisLetters = $(this).find('.js-sortLink-letter').html();

        const isLetters = $(this).find('.js-sortLink-letter').data('letters') ? true : false;
        
        toggleText.html($thisText);
        isLetters ? toggleLetters.html($thisLetters) : toggleLetters.html('');

        $('.js-sort-link').show();
        $(this).hide();
    });
    $(document).on('mouseup touchstart', function (e) {
        if ($(e.target).closest('.js-sort').length === 0 && $('.js-sort').hasClass('open')) {
            sortDropDown.toggle();
            contextOverlay();
        }
    });
}

initSort();
initDeduce();
export const reinitDropDown = () => {
    if ($('.js-deduce-select').length) {
        initDeduce();
    }
    if ($('.js-sort').length) {
        initSort();
    }
}